<template>
  <Navbar homepage logourl="#" />

  <!-- ======= Carousel Section ======= -->
  <section id="carousel">
    <div class="carousel-content" data-aos="fade-up">
      <h2>Tester na wynajem</h2>
      <h3>Nie kupuj, wynajmuj!</h3>
      <div>
        <router-link :to="registrationPath"
          ><a type="button" id="regButton" class="btn-get-started"
            >Zarejestruj się</a
          ></router-link
        >
        <router-link :to="loginPath"
          ><a type="button" id="loginButton" class="btn-projects"
            >Zaloguj się</a
          ></router-link
        >
      </div>
    </div>

    <div class="carousel-slider">
      <div class="swiper-slide"></div>
    </div>
  </section>
  <!-- End Carousel Section -->
  <section id="service_description">
    <div class="container" data-aos="fade-up">
      <div class="row">
        <div class="col-lg-6">
          <img src="../assets/images/screen_demo_1.png" alt="" />
        </div>
        <div class="col-lg-6">
          <div class="section-caption">
            <h2>Czym jest "Tester na wynajem"?</h2>
          </div>
          <div class="section-content">
            <p>
              Jeśli potrzebujesz testera, by sprawniej i skuteczniej świadczyć
              usługi związane z diagnostyką i naprawą pojazdów, prowadzisz
              działalność gospodarczą lub zawodową, ale:
            </p>
            <ul>
              <li>nie chcesz inwestować w zakup urządzenia</li>
              <li>
                nie masz pewności czy urządzenie sprawdzi się w Twoim warsztacie
              </li>
              <li>
                chcesz zapoznać się z funkcjonalnością urządzenia bez zobowiązań
              </li>
              <li>
                chcesz mieć możliwość zwrotu urządzenia, gdy nie będzie Ci już
                potrzebne
              </li>
            </ul>
            <p>
              to "Tester na wynajem" jest usługą stworzoną właśnie dla Ciebie!
              <br />
              W przystępnej cenie otrzymasz w pełni funkcjonalny tester i
              samodzielnie decydujesz, jak długo chcesz z niego korzystać.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section id="service_utilities">
    <div class="container" data-aos="fade-up">
      <div class="section-caption">
        <h2>Co otrzymasz w ramach usługi?</h2>
      </div>
      <div class="section-content">
        <ul>
          <li>
            &nbsp;wyprodukowany w Polsce tester diagnostyczny wraz z adapterem
            J1962
          </li>
          <li>
            &nbsp;dedykowane oprogramowanie w języku polskim, przeznaczone na
            komputery stacjonarne oraz przenośne z systemem Windows 10 lub
            nowszym
          </li>
          <li>
            &nbsp;możliwość pobrania aktualizacji oprogramowania - aktualizacje
            pojawiają się co dwa miesiące - każda wzbogaca oprogramowanie o
            możliwość diagnozy kolejnych modeli pojazdów i wersji sterowników
          </li>
          <li>
            &nbsp;pomoc techniczną w zakresie instalacji oraz obsługi
            oprogramowania i urządzenia - dostępną telefonicznie oraz poprzez
            pocztę elektroniczną
          </li>
          <li>
            &nbsp;jeśli urządzenie ulegnie awarii - szybką wymianę na sprawne
            urządzenie
          </li>
          <li>
            &nbsp;możliwość wyboru jak długo będziesz korzystać z urządzenia -
            minimalny okres korzystania z usługi wynosi 1 miesiąc i możesz go w
            każdej chwili przedłużyć lub dokonać zwrotu urządzenia
          </li>
        </ul>
      </div>
    </div>
  </section>
  <section id="about_our_device">
    <div class="container" data-aos="fade-up">
      <div class="section-caption">
        <h2>O naszym testerze</h2>
      </div>
      <div class="section-content">
        <p>
          Kliknij
          <a href="/?section=/porownaj" target="_blank">tutaj</a>, aby zapoznać
          się z parametrami technicznymi urządzenia. W usłudze "Tester na
          wynajem" udostępniane są losowo urządzenia NEX oraz CDIF/3+.<br />
          Kliknij
          <a href="/?section=/mozliwosci/lista#/87/135" target="_blank">tutaj</a
          >, aby zapoznać się z listą obsługiwanych pojazdów i systemów.
        </p>
        <h2 style="color: #0a53be" class="text-center">
          Do czego może przydać Ci się nasz tester?
        </h2>
      </div>
      <div class="row gy-4">
        <div class="col-lg-6" data-aos="fade-up" data-aos-delay="200">
          <div class="tile">
            <div class="icon">
              <img
                src="../assets/badge_FILL0_wght400_GRAD0_opsz48.svg"
                alt=""
              />
            </div>
            <h4><a id="about">Identyfikacja</a></h4>
            <p>
              Uzyskaj informacje o diagnozowanym systemie.
              <br /><br />
              Identyfikacja pozwala na rozpoznanie i czytelną prezentację danych
              identyfikacyjnych systemu. Potrzebujesz zamówić części zamienne?
              Odczytaj informacje o wersji części, kalibracji, wersji
              oprogramowania sterownika, numerze VIN pojazdu i wiele innych.
            </p>
          </div>
        </div>
        <div class="col-lg-6" data-aos="fade-up" data-aos-delay="200">
          <div class="tile">
            <div class="icon">
              <img
                src="../assets/stethoscope_FILL0_wght400_GRAD0_opsz48.svg"
                alt=""
              />
            </div>
            <h4><a id="about">Odczyt i kasowanie kodów usterek</a></h4>
            <p>
              Umożliwia czytelną i jasną prezentację oraz kasowanie usterek
              zarejestrowanych w pamięci systemu.
              <br /><br />Zaświeciła się kontrolka? Co może być nie tak? Skróć
              czas naprawy, dzięki informacjom o błędach, zarejestrowanych
              podczas pracy systemu.
            </p>
            <br />
          </div>
        </div>
        <div class="col-lg-6" data-aos="fade-up" data-aos-delay="200">
          <div class="tile">
            <div class="icon">
              <img src="../assets/list_FILL0_wght400_GRAD0_opsz48.svg" alt="" />
            </div>
            <h4><a id="about">Parametry bieżące</a></h4>
            <p>
              Odczyt parametrów bieżących pozwala na czytelne zaprezentowanie
              szeregu parametrów dotyczacych pracy systemu.
              <br /><br />Chcesz znać napięcie zasilania czujnika? Ciśnienie w
              kolektorze dolotowym? A może chcesz zaobserwować zmiany
              poszczególnych parametrów w określonym czasie? Oceń pracę
              poszczególnych komponentów w pojeździe dzięki bieżącym informacjom
              o ich stanie.
            </p>
          </div>
        </div>
        <div class="col-lg-6" data-aos="fade-up" data-aos-delay="200">
          <div class="tile">
            <div class="icon">
              <img
                src="../assets/switches_FILL0_wght400_GRAD0_opsz48.svg"
                alt=""
              />
            </div>
            <h4 class="title"><a id="about">Aktywacje</a></h4>
            <p>
              Umożliwiają uruchamianie i sterowanie szeregiem elementów
              wykonawczych.
              <br /><br />Przetestuj sprawność działania układów
              elektronicznych.
            </p>
          </div>
        </div>
        <div class="col-lg-6" data-aos="fade-up" data-aos-delay="200">
          <div class="tile">
            <div class="icon">
              <img
                src="../assets/change_circle_FILL0_wght400_GRAD0_opsz48.svg"
                alt=""
              />
            </div>
            <h4><a id="about">Adaptacje</a></h4>
            <p>
              Wyreguluj działanie poszczególnych systemów.
              <br /><br />Wymiana oleju? - Wykonaj kasowanie inspekcji.<br />
              Wymiana okładzin hamulcowych? - Cofnij zaciski. <br />Diesel nie
              musi dymić! - Wykonaj wypalanie filtra DPF.<br />
              A może wymieniłeś akumulator, uzupełniłeś dodatek do paliwa?
              <br />
              Po prostu kliknij i wykonaj niezbędną adaptację.
            </p>
          </div>
        </div>
        <div class="col-lg-6" data-aos="fade-up" data-aos-delay="200">
          <div class="tile">
            <div class="icon">
              <img
                src="../assets/select_check_box_FILL0_wght400_GRAD0_opsz48.svg"
                alt=""
              />
            </div>
            <h4 class="title"><a id="about">Kodowania</a></h4>
            <p>
              Zmieniaj ustawienia sterownika.
              <br /><br />Nowe wtryskiwacze, wymiana czujników TPMS? Zmiana
              konfiguracji pojazdu? Wykonaj kodowanie i dostosuj zapisane w
              sterowniku ustawienia.
            </p>
          </div>
        </div>
        <div class="col-lg-6" data-aos="fade-up" data-aos-delay="200">
          <div class="tile">
            <div class="icon">
              <img
                src="../assets/captive_portal_FILL0_wght400_GRAD0_opsz48.svg"
                alt=""
              />
            </div>
            <h4 class="title"><a id="about">Pass-Thru</a></h4>
            <p>
              Tester jest wspierany przez oprogramowania producentów pojazdów.
              Wykonaj procedury wymagające ich autoryzacji.
            </p>
          </div>
        </div>
        <div class="col-lg-6" data-aos="fade-up" data-aos-delay="200">
          <div class="tile">
            <div class="icon">
              <img
                src="../assets/summarize_FILL0_wght400_GRAD0_opsz48.svg"
                alt=""
              />
            </div>
            <h4><a id="about">Raport z przeprowadzonej diagnozy</a></h4>
            <p>
              Wygeneruj dokument, zawierający zapis przeprowadzonych w pojeździe
              czynności diagnostycznych.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section id="service_cost">
    <div class="container" data-aos="fade-up">
      <div class="section-caption">
        <h2>Koszt wynajmu</h2>
      </div>
      <div class="section-content">
        <p>Przejrzysty cennik to podstawa</p>
        <p><b>Ile zapłacisz?</b></p>
        <p>
          <b>{{ subscriptionPrice }} zł</b> netto za każdy
          <b>miesiąc</b> wynajmu <br />
          <span
            v-if="
              activationPricePromo === null ||
              activationPricePromo === undefined
            "
            ><b>{{ activationPrice }} zł</b></span
          >
          <span v-else class="strikethrough" style="margin-right: 0.5rem"
            ><b>{{ activationPrice }} zł</b></span
          >
          <span
            v-if="
              activationPricePromo === null ||
              activationPricePromo === undefined
            "
          ></span>
          <span v-else style="color: red"
            ><b>{{ activationPricePromo }} zł</b></span
          >
          netto - opłata aktywacyjna (nie dotyczy przy przedłużaniu wynajmu)
        </p>
      </div>
    </div>
  </section>

  <section id="how_to_order">
    <div class="container" data-aos="fade-up">
      <div class="section-caption">
        <h2>Jak zamówić?</h2>
      </div>
      <div class="section-content">
        <p>
          Tylko kilka małych kroków dzieli Cię od otrzymania naszego testera:
        </p>
        <ul>
          <li>&nbsp;zarejestruj się i złóż zamówienie</li>
          <li>
            &nbsp;jeśli to Twoje pierwsze zamówienie - opłać je, wykonując
            przelew z rachunku bankowego, w którym dane o posiadaczu rachunku
            pokrywają się z danymi, które podałeś/aś podczas rejestracji
          </li>
          <li>
            &nbsp;po zaksięgowaniu płatności i weryfikacji Twoich danych wyślemy
            Ci tester diagnostyczny
          </li>
          <li>
            &nbsp;rozpoczynasz korzystanie z w pełni funkcjonalnego, wysokiej
            jakości urządzenia
          </li>
          <li>
            &nbsp;jeśli Twój abonament dobiega końca, możesz go przedłużyć lub
            odesłać nam urządzenie w ciągu 7 dni po zakończeniu abonamentu
          </li>
        </ul>
        <img src="../assets/images/banner.png" alt="" />
      </div>
    </div>
  </section>
  <section id="contact">
    <div class="container" data-aos="fade-up">
      <div class="section-caption">
        <h2>Masz pytania? Skontaktuj się z nami!</h2>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="mb-4 text-center">
            <img
              src="../assets/location_on_FILL0_wght400_GRAD0_opsz48.svg"
              alt=""
            />
            <h3>Adres</h3>
            <address>
              AXES System sp. z o.o.<br />
              ul. Raciborskiego 35<br />
              80-215 Gdańsk <br />
              Numer NIP: 9571067410<br />
              Polska
            </address>
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-4 text-center">
            <img src="../assets/phone.svg" alt="" />
            <h3>Numer telefonu</h3>
            <a href="tel:+48587321949">+48 58 732 19 49</a><br />
            <p>
              Infolinia czynna od 8:00 do 16:00 <br />
              od poniedziałku do piątku
            </p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-4 text-center">
            <img src="../assets/mail_FILL0_wght400_GRAD0_opsz48.svg" alt="" />
            <h3>Email</h3>
            <p>
              <a href="mailto:info@cdif3.com">info@cdif3.com</a><br />
              <a href="mailto:pomoc@cdif3.com">pomoc@cdif3.com</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Stopka -->
  <Footer />
</template>

<script>
import { makeRequest } from "@/utils/helpers";
import { RequestResult } from "@/utils/requestResult";
import { RoutePath } from "@/utils/routePath";
import Footer from "@/components/Footer.vue";
import Navbar from "@/components/Navbar.vue";

export default {
  name: "homepage",
  components: { Navbar, Footer },
  data() {
    return {
      subscriptionPrice: null,
      //subscriptionDays: null,
      activationPrice: null,
      activationPricePromo: null,

      loginPath: RoutePath.Login,
      registrationPath: RoutePath.Registration,
      regulationsPath: RoutePath.Regulations
    };
  },

  async created() {
    await this.getMonthlySubscriptionData();
  },

  methods: {
    async getMonthlySubscriptionData() {
      let getMonthlySubscriptionDataResponse = await makeRequest(
        this.hostname + `?action=${this.request.GetMonthlySubscriptionData}`,
        "GET"
      );

      switch (getMonthlySubscriptionDataResponse.data.error) {
        case RequestResult.OK: {
          this.subscriptionPrice =
            getMonthlySubscriptionDataResponse.data.data.subscription_rental_1m;
          //this.subscriptionDays =
            //getMonthlySubscriptionDataResponse.data.data.subscription_days_1m;
          this.activationPrice =
            getMonthlySubscriptionDataResponse.data.data.subscription_rental_activ_fee;
          this.activationPricePromo =
            getMonthlySubscriptionDataResponse.data.data.subscription_rental_activ_fee_promo;
          break;
        }
        case RequestResult.GeneralError: {
          break;
        }
        case RequestResult.InvalidCookie:
        case RequestResult.CookieExpired: {
          this.$router.push(this.routePath.Login);
          break;
        }
      }
    },
  },
};
</script>

<style scoped>
#about_our_device .tile {
  padding: 30px;
  box-shadow: 10px 10px 15px rgba(70, 70, 90, 0.1);
  background: #fff;
  border-radius: 2.5%;
  transition: 0.5s;
  height: 100%;
}
#about_our_device .tile:hover {
  box-shadow: 0 0 30px rgba(70, 70, 90, 0.2);
  transform: translateY(-5px);
  -webkit-transform: translateY(-5px);
  -moz-transform: translateY(-5px);
}
#about_our_device .tile p {
  text-align: left;
  font-size: 15px;
  line-height: 25px;
  margin-left: 75px;
}
#about_our_device .tile h4 {
  text-align: left;
  margin-left: 75px;
}
#about_our_device .tile .icon {
  float: left;
}

#contact .section-content h3 {
  color: gray;
  text-transform: uppercase;
}

#about {
  color: #0a53be;
}

.flex-grow-0 {
  flex-grow: 0;
}

#carousel {
  width: 100%;
  height: 60vh;
  position: relative;
  background: no-repeat center url("../assets/images/16.jpeg");
  background-size: cover;
  padding: 0;
}
#carousel .carousel-content {
  position: absolute;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
}
#carousel .carousel-content h2 {
  color: #0c2e8a;
  margin-bottom: 30px;
  font-size: 64px;
  font-weight: 700;
}
#carousel .carousel-content h2 span {
  color: #50d8af;
  text-decoration: underline;
}
@media (max-width: 767px) {
  #carousel .carousel-content h2 {
    font-size: 34px;
  }
}
#carousel .carousel-content .btn-get-started,
#carousel .carousel-content .btn-projects {
  font-family: "Raleway", sans-serif;
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 1px;
  display: inline-block;
  padding: 10px 32px;
  border-radius: 2px;
  transition: 0.5s;
  margin: 10px;
  color: #fff;
}
#carousel .carousel-content .btn-get-started {
  background: #0c2e8a;
  border: 2px solid #0c2e8a;
}
#carousel .carousel-content .btn-get-started:hover {
  background: none;
  color: #0c2e8a;
}
#carousel .carousel-content .btn-projects {
  background: #50d8af;
  border: 2px solid #50d8af;
}
#carousel .carousel-content .btn-projects:hover {
  background: none;
  border: 2px solid #0c2e8a;
  color: #0c2e8a;
}
#carousel .carousel-slider {
  z-index: 8;
  height: 60vh;
}
#carousel .carousel-slider::before {
  content: "";
  background-color: rgba(255, 255, 255, 0.7);
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 7;
}
#carousel .carousel-slider .swiper-slide {
  background-size: cover;
  background-position: center;
  background-repeat: repeat;
  transition-property: opacity;
}
</style>
